const languages = {
  'en-CA': 'English'
  // 'de-DE': 'German'
}

export default languages;
